export const COOKIES_INFO_LINK = 'https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser'
export const CNIL_LINK = 'https://www.cnil.fr'
export const COOKIE_FIELD_NAME = 'acceptCookies'
